import { render } from "./FormSectionPage.vue?vue&type=template&id=5a28528f&scoped=true"
import script from "./FormSectionPage.vue?vue&type=script&lang=js"
export * from "./FormSectionPage.vue?vue&type=script&lang=js"

import "./FormSectionPage.vue?vue&type=style&index=0&id=5a28528f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a28528f"]])

export default __exports__